import { simpleSet } from '@r/reducers/utils';

const setCalculationModeMarkupLabel = simpleSet as
  redux.reducers.calculationMode.settings.materials.markup.label;

export const label = setCalculationModeMarkupLabel(
  'SET_CALCULATION_MODE_MARKUP_LABEL',
  ''
);
